<template lang="pug">
el-dialog(
    title="添加比赛" 
    width="95%",
    :visible.sync="visible",
    :append-to-body="true",
    :modal-append-to-body="false",
    @close="closeForm()")
        el-row
            el-col(:span="11")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='searchKeyword' clearable='', style='width:80%;'  placeholder="请输入比赛ID/名称")
                            el-col(:span='2')    
                                el-button(@click="getDataList" style='float:right;' icon='el-icon-search' ) 查询
                    div
                        el-table(:data="leftData" border v-loading='memberOrgListLoading' @selection-change="checkAll" max-height="300")
                            el-table-column(type="selection" align='center')
                            el-table-column(prop="matchId" label="比赛ID" align='center')
                            el-table-column(prop="matchName" label="比赛名称" align='center'  )
                            el-table-column(prop="applySize" label="签位" align='center' )
                        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            el-col(:span="2")
                div.opSetting
                    div(@click="handelSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                    div.spacing(@click="handleRemoveSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
            el-col(:span="11")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择比赛
                    div
                        el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300" )
                            el-table-column(type="selection" align='center')
                            el-table-column(prop="matchId" label="比赛ID" align='center')
                            el-table-column(prop="matchName" label="比赛名称" align='center'  )
                            el-table-column(prop="applySize" label="签位" align='center' )
        span.dialog-footer(slot="footer")
            el-button(@click="comfirmReferee" type="primary") 确 定
            el-button(@click="closeForm") 取 消
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      leftData: [],
      loading: null,
      buttonSize: "large",
      rightData: [], // 右边列表
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      memberOrgListLoading: false,
      orgIdList: [],
      ctId: "",
      matchId: "",
      ctRefereeSetList: [],
      searchKeyword: '',
      matchType: null
    };
  },
  methods: {
    init(row, selChangeData) {
      // this.matchId = selChangeData[0].ctId
      this.ctId = row.id;
      this.matchType = row.matchType
      this.leftData = [];
      this.rightData = [];
      this.nowSelectData = [];
      this.nowSelectRightData = [];

      this.visible = true;
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/selfSelection/queryPageCompetitionList`
        ),
        method: "post",
        data: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          selfCtId: this.ctId,
          matchType: this.matchType,
        }),
      }).then((data) => {
        console.log(data);
        if (data && data.code === 0) {
          this.leftData = data.page.rows;
          this.totalPage = data.page.total;
        } else {
          this.leftData = [];
          this.totalPage = 0;
        }
      });
    },
    getDataList() {
      this.memberOrgListLoading = true;
      this.$http({
        url: this.$http.adornUrl(
          "/ctCompetition/selfSelection/queryPageCompetitionList"
        ),
        method: "post",
        data: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          selfCtId: this.ctId,
          matchType: 1,
          searchKeyword: this.searchKeyword,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.rows;
          this.totalPage = data.page.total;
        } else {
          this.leftData = [];
          this.totalPage = 0;
        }
        this.memberOrgListLoading = false;
      });
    },
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    comfirmReferee() {
      if (this.rightData.length === 0) {
        this.$message.error("请勾选要关联的比赛！");
        return;
      }
      this.ctRefereeSetList = [];
      this.rightData.forEach((data) => {
        this.ctRefereeSetList.push(data.id);
      });
      this.openFullScreen();
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/selfSelection/updateRelationCompetition`
        ),
        method: "post",
        data: {
          selfCtId: this.ctId,
          operateType: 10,
          bindCtIds: this.ctRefereeSetList,
        },
      })
        .then((data) => {
          if (data && data.code === 0) {
            this.visible = false;
            this.$message.success("操作成功!");
            this.$emit("refreshDataList");
          } else {
            this.$message.success("操作失败!");
          }
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 关闭
    closeForm() {
      this.visible = false;
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    checkAll(val) {
      this.nowSelectData = val;
    },
    checkRightAll(val) {
      this.nowSelectRightData = val;
    },
    // 选中
    handelSelect() {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData);
      this.handleRemoveTabList(this.nowSelectData, this.leftData);
      this.nowSelectData = [];
    },
    // 取消
    handleRemoveSelect() {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      );
      console.log(this.rightData);
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData);
      this.nowSelectRightData = [];
    },
    handleConcatArr(rightData, nowSelectData) {
      let arr = [];
      arr = arr.concat(rightData, nowSelectData);
      return arr;
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]["matchName"] === originalArr[k]["matchName"]) {
              originalArr.splice(k, 1);
            }
          }
        }
      }
    },
  },
};
</script>
